module.exports = __webpack_public_path__ + "images/calc-pdf-bg_31ff606804beda9313ba7db5f2eac07d.jpg";